import * as React from 'react';
import InboundAutomationSidebar from './InboundAutomationSidebar';

class InboundAutomationHome extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <InboundAutomationSidebar />
          <div className='h-100 d-flex align-items-center'>
            <div
              className='p-2 col-example'
              style={{
                textAlign: 'center',
                marginLeft: '100px',
                marginRight: '100px',
                width: '60%',
              }}
            >
              <i className='fa-regular fa-envelope-open' size='6x' />

              <h2 style={{ fontWeight: 'bolder', fontStyle: 'italic' }}>
                InboundAutomation
              </h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InboundAutomationHome;
